export default __webpack_public_path__ + "static/media/c.d03887a1.png";